import { Component, OnInit, OnDestroy } from '@angular/core'
import * as model from '../../../models'
import { Store } from '@ngrx/store'
import { AppState } from '../../../reducers'
import { Observable, Subscription } from 'rxjs'

import { MessageActions, TicketDesignActions } from '../../../actions'
import { ErrorHandlerService, TicketDesignApi } from '../../../services'

let FileSaver = require('../../../FileSaver');

@Component({
	selector: 'ticket-designs',
	template: `
			<spinner [visible]="(showSpinner$|async)" >
			</spinner>
			<leo-box boxHeadline="Ticket Design" boxCssClass="box--no-padding">
				<ticket-print-presentation
					[hideContent] = "(showSpinner$|async)"
					[ticketDesignAssigned]="(ticketPrintTicketDesignAssigned)"
					[ticketDesignExists]="(ticketPrintTicketDesignExists)"
					[previewDataUrl]="previewDataUrlTicketPrint$ | async"
					[ticketDesignFileName]="ticketPrintFileName$ | async"
					[allowDeletion]="allowTicketDesignUsageTicketPrintDeletion"
					(addTicketDesignChange)="addTicketPrintDesign($event)"
					(saveTicketDesignAssociationClick)="saveTicketDesignUsageTicketPrint()"
					(deleteTicketDesignClick)="deleteTicketDesignTicketPrint()"
					(deleteTicketDesignAssociationClick)="deleteTicketDesignUsageTicketPrint()"
					(downloadTicketDesignClick)="downloadTicketDesign(ticketPrintTicketDesignUsage)"
				></ticket-print-presentation>
			</leo-box>

			<leo-box boxHeadline="Print@Home" boxCssClass="box--no-padding">
				<print-at-home-presentation
					[hideContent] = "(showSpinner$|async)"
					[ticketDesignAssigned] = "(printAtHomeTicketDesignAssigned)"
					[ticketDesignExists] = "(printAtHomeTicketDesignExists)"
					[previewDataUrl]="previewDataUrlPrintAtHome$ | async"
					[ticketDesignFileName]="printAtHomeFileName$ | async"
					[allowDeletion]="allowTicketDesignUsagePrintAtHomeDeletion"
					(addTicketDesignChange)="addPrintAtHomeDesign($event)"
					(saveTicketDesignAssociationClick)="saveTicketDesignUsagePrintAtHome()"
					(deleteTicketDesignClick)="deleteTicketDesignPrintAtHome()"
					(deleteTicketDesignAssociationClick)="deleteTicketDesignUsagePrintAtHome()"
					(downloadTicketDesignClick)="downloadTicketDesign(printAtHomeTicketDesignUsage)"
				></print-at-home-presentation>
			</leo-box>
			`
})

export class TicketDesignComponent implements OnInit, OnDestroy {

	private ticketPrintTicketDesignAssigned: boolean;
	private ticketPrintTicketDesignExists: boolean;

	private ticketPrintTicketDesignUsage: model.TicketDesignUsage;
	private ticketPrintTicketDesignUuid: string;

	private printAtHomeTicketDesignAssigned: boolean;
	private printAtHomeTicketDesignExists: boolean;

	private printAtHomeTicketDesignUsage: model.TicketDesignUsage;
	private printAtHomeTicketDesignUuid: string;

	private allowTicketDesignUsageTicketPrintDeletion: boolean = true;
	private allowTicketDesignUsagePrintAtHomeDeletion: boolean = true;


	private previewDataUrlTicketPrint$: Observable<string>
	private previewDataUrlPrintAtHome$: Observable<string>
	private ticketPrintFileName$: Observable<string>
	private printAtHomeFileName$: Observable<string>
	private showSpinner$: Observable<boolean>
	private ticketDesignTypes = model.TicketDesignTypes

	private subscriptions: Subscription[] = new Array<Subscription>();

	constructor(
		private store$: Store<AppState>,
		private ticketDesignActions: TicketDesignActions,
		private ticketDesignApi: TicketDesignApi,
		private messageActions: MessageActions,
		private errorHandler: ErrorHandlerService) {

	}

	ngOnInit() {
		this.store$.select("eventServerState", "event", "currentEvent").subscribe((event: model.Event) => {
			if (event == null) return;

			this.previewDataUrlTicketPrint$ = this.store$.select("eventServerState", "ticketDesigns", "previewTicketPrintDesignBase64")
				.map(base64 => base64 ? this.base64ToImageSrc(base64) : "")

			this.previewDataUrlPrintAtHome$ = this.store$.select("eventServerState", "ticketDesigns", "previewPrintAtHomeDesignBase64")
				.map(base64 => base64 ? this.base64ToImageSrc(base64) : "")

			this.printAtHomeFileName$ = this.store$.select("eventServerState", "ticketDesigns", "printAtHomeTicketDesignUsage")
				.map(tdu => tdu ? tdu.ticketDesignFileName : "")

			this.ticketPrintFileName$ = this.store$.select("eventServerState", "ticketDesigns", "ticketPrintTicketDesignUsage")
				.map(tdu => tdu ? tdu.ticketDesignFileName : "")

			this.subscriptions.push(
				this.store$.select("eventServerState", "ticketDesigns", "ticketPrintTicketDesignUsage")
				.subscribe(
					tdu => {
						if (tdu) {
							this.ticketPrintTicketDesignAssigned = true;
							this.ticketPrintTicketDesignUsage = tdu;
							this.allowTicketDesignUsageTicketPrintDeletion =
							tdu.defaultDesign ? false : true;
						} else {
							this.ticketPrintTicketDesignAssigned = false;
						}
					}
				)
			);

			this.subscriptions.push(
				this.store$.select("eventServerState", "ticketDesigns", "ticketPrintDesignUuid")
				.subscribe(
					tktDesign => {
						if (tktDesign) {
							this.ticketPrintTicketDesignExists = true;
							this.ticketPrintTicketDesignUuid = tktDesign;
						} else {
							this.ticketPrintTicketDesignExists = false;
						}
					}
				)
			);

			this.subscriptions.push(
				this.store$.select("eventServerState", "ticketDesigns", "printAtHomeTicketDesignUsage")
				.subscribe(
					tdu => {
						if (tdu) {
							this.printAtHomeTicketDesignAssigned = true;
							this.printAtHomeTicketDesignUsage = tdu;
							this.allowTicketDesignUsagePrintAtHomeDeletion =
								tdu.defaultDesign ? false : true;
						} else {
							this.printAtHomeTicketDesignAssigned = false;
						}
					}
				)
			);

			this.subscriptions.push(
				this.store$.select("eventServerState", "ticketDesigns", "printAtHomeTicketDesignUuid")
				.subscribe(
					tktDesign => {
						if (tktDesign) {
							this.printAtHomeTicketDesignUuid = tktDesign;
							this.printAtHomeTicketDesignExists = true;
						} else {
							this.printAtHomeTicketDesignExists = false;
						}
					}
				)
			);

			this.showSpinner$ = this.store$.select("eventServerState", "ticketDesigns", "showSpinner")
		})
	}

	ngOnDestroy() {
		this.subscriptions.forEach(subscription => subscription.unsubscribe());
	}

	public addTicketPrintDesign(file: File) {
		this.store$.dispatch(this.ticketDesignActions.showSpinner())
		this.store$.dispatch(this.ticketDesignActions.uploadTicketDesign(file, this.ticketDesignTypes.TICKET_PRINT))
	}

	public addPrintAtHomeDesign(file: File) {
		this.store$.dispatch(this.ticketDesignActions.showSpinner())
		this.store$.dispatch(this.ticketDesignActions.uploadTicketDesign(file, this.ticketDesignTypes.PRINT_AT_HOME))
	}

	public deleteTicketDesignUsageTicketPrint() {
		this.store$.dispatch(this.ticketDesignActions.deleteTicketDesignUsageTicketPrint(this.ticketPrintTicketDesignUsage.uuid))
	}

	public deleteTicketDesignTicketPrint() {
		this.store$.dispatch(this.ticketDesignActions.deleteTicketDesignTicketPrint(this.ticketPrintTicketDesignUuid));
	}

	public deleteTicketDesignUsagePrintAtHome() {
		this.store$.dispatch(this.ticketDesignActions.deleteTicketDesignUsagePrintAtHome(this.printAtHomeTicketDesignUsage.uuid))
	}

	public deleteTicketDesignPrintAtHome() {
		this.store$.dispatch(this.ticketDesignActions.deleteTicketDesignPrintAtHome(this.printAtHomeTicketDesignUuid));
	}

	public saveTicketDesignUsageTicketPrint() {
		this.store$.take(1).subscribe((state: AppState) => {
			this.store$.dispatch((this.ticketDesignActions.saveTicketDesignUsage(
				state.eventServerState.ticketDesigns.ticketPrintDesignUuid,
				state.eventServerState.event.currentEvent.uuid,
				this.ticketDesignTypes.TICKET_PRINT
			)))
		})
	}

	public saveTicketDesignUsagePrintAtHome() {
		this.store$.take(1).subscribe((state: AppState) => {
			this.store$.dispatch((this.ticketDesignActions.saveTicketDesignUsage(
				state.eventServerState.ticketDesigns.printAtHomeTicketDesignUuid,
				state.eventServerState.event.currentEvent.uuid,
				this.ticketDesignTypes.PRINT_AT_HOME
			)))
		})
	}

	public downloadTicketDesign(ticketDesignUsage: model.TicketDesignUsage) {
		this.ticketDesignApi.loadTicketDesignSvg(ticketDesignUsage._links.ticket_design_svg.href)
			.subscribe(svgString => {
				const blob = new Blob([svgString], {type: "image/svg+xml;charset=utf-8"});
				FileSaver.saveAs(blob, ticketDesignUsage.ticketDesignFileName, true);
			}, error => {
				let errorMessage = this.errorHandler.getErrorMessage(error, "Das Ticket-Design konnte nicht heruntergeladen werden.")
				this.store$.dispatch(this.messageActions.displayMessage(errorMessage, "error"))
			})
	}

	private base64ToImageSrc = (base64: string): string => {
		return "data:image/png;base64," + base64
	}
}



// WEBPACK FOOTER //
// ./src/app/components/event-components/ticket-designs/ticket-design.component.ts